import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/sites");

export const Route = createFileRoute("/sites")({
  head: () => ({
    meta: [
      { title: "Sites — LevelLoad" },
      { name: "description", content: "Sites — LevelLoad transport planning." },
      { property: "og:title", content: "Sites — LevelLoad" },
      { property: "og:description", content: "Sites — LevelLoad transport planning." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
